export var mapAggregatedEventsCount = function (x) {
    x.aggregatedEventsCount = x.metadata && x.metadata.aggregatedEventIds
        ? x.metadata.aggregatedEventIds.split(";").length
        : 0;
    return x;
};
//# sourceMappingURL=mapAggregatedEventsCount.js.map